import { assertEnvPresent } from "@every.org/common/src/helpers/getEnv";

import { getWindow } from "src/utility/window";

export function getAPIOrigin() {
  const origin =
    [
      "staging.every.org",
      "www.every.org",
      // Embed (iframed donate) hosts — served by this same app but on a
      // dedicated origin, so the API origin must be resolved explicitly
      // (same-origin /api/* is 404'd by the middleware on these hosts)
      "embed-staging.every.org",
      "embed.every.org",
    ].includes(getWindow()?.location?.host || "") ||
    getWindow() === undefined ||
    (getWindow()?.location?.host || "").includes("localhost") ||
    // Local dev host for the embedded donate flow (a distinct origin from
    // localhost:3000 so the API's embed session branch is exercised)
    (getWindow()?.location?.host || "").includes("127.0.0.1")
      ? assertEnvPresent(
          process.env.NEXT_PUBLIC_API_ORIGIN,
          "NEXT_PUBLIC_API_ORIGIN"
        )
      : "";
  return origin;
}
